import {
  Home,
  HomeFilled,
  Machine,
  Notification,
  Operator,
  Report
} from '../assets/images';
import { routePaths } from './route-paths';

export const generateSites = (t) => [
  {
    title: t('navigation.overview'),
    icon: <Home className="icon-menu home-icon" />,
    filledIcon: <HomeFilled className="icon-menu home-icon filled-icon" />,
    path: routePaths.overview
  },
  {
    title: t('navigation.myMachine'),
    icon: <Machine className="icon-menu" />,
    path: routePaths.myMachine,
    subPath: [routePaths.claimingProcess]
  },
  {
    title: t('navigation.cleaningReport'),
    icon: <Report className="icon-menu" />,
    path: routePaths.cleaningReport
  },
  {
    title: t('navigation.notifications'),
    icon: <Notification className="icon-menu" />,
    path: routePaths.notifications
  },
  {
    title: t('navigation.operators'),
    icon: <Operator className="icon-menu" />,
    path: routePaths.operators
  }
];
